import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminNewslettersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('newsletter');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
